import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
    name: 'remainingDays',
    standalone: false
})
export class RemainingDaysPipe implements PipeTransform {

  transform(value: any): string {
    if (!value) return '';

    const currentDate = new Date();
    const validUptoDate = new Date(value);
    const timeDiff = validUptoDate.getTime() - currentDate.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (daysDiff < 0) {
      return 'Expired';
    } else {
      return `Expires in ${daysDiff} days`;
    }
  }
}
